import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';

@UntilDestroy()
@Component({
    selector: 'ifb-user-role-assignees-list',
    templateUrl: './user-role-assignees-list.component.html',
    styleUrls: ['./user-role-assignees-list.component.scss'],
    standalone: false
})
export class UserRoleAssigneesListComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  dataSource = new MatTableDataSource<any>();
  noDataFound: boolean;
  tableColumns: string[] = [
    'clientName',
    'username',
    'externalId',
    'firstName',
    'middleName',
    'lastName',
    'lastLoginDate_IP',
    'status',
  ];

  constructor(private readonly activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;

    this.activatedRoute.data.pipe(untilDestroyed(this))
      .subscribe(result => {
        this.dataSource.data = result.userRoleAssignees.values;
        this.noDataFound = !(result.userRoleAssignees.totalCount > 0);
      });
  }
}  